import React from 'react'

export const DropdownContext = React.createContext()

export const { Provider: DropdownContextProvider } = DropdownContext
